// i18n
import { useTranslation } from "react-i18next";

type Props = {
  title: string;
  descriptions?: string[];
  translationKey: string;
};

const TextBlock = ({ title, descriptions, translationKey }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="w-full">
      <p className="text-2xl font-extrabold leading-9 text-primary">{t(`${translationKey}.${title}`)}</p>
      <div className="mt-3 flex flex-col gap-3">
        {descriptions?.map((description, index) => (
          <p key={index} className="text-sm font-normal leading-[30px]">
            {t(`${translationKey}.${description}`)}
          </p>
        ))}
      </div>
    </div>
  );
};

export default TextBlock;
